import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FooterLink } from '@shared/model/lender-config.model';

@Component({
  selector: 'arcdx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
  @Input() public footerLinks: FooterLink[];
  /** copyright (string) */
  @Input() public copyright: string;
  /** toggle dark mode */
  @Input() public darkMode: boolean;
}
